export default theme => ({
  finalUrl: {
    color: theme.palette.disabled.main,
  }
});
